import React from "react";
import { PageTitleComponent } from "../../";
import WalkRouteMap from "./WalkRouteMap";

export default class WalkMapCard extends React.Component {

  render() {
    const { appointment } = this.props;

    if (
      !appointment ||
      !appointment.appointment_status ||
      appointment.appointment_status.name !== "Completed"
    ) {
      return null;
    }

    const route = appointment.route || [];
    const coordinates =
      appointment.home &&
      appointment.home.address &&
      appointment.home.address.coordinates;
    const marker = coordinates && {
      lat: parseFloat(coordinates.latitude),
      lng: parseFloat(coordinates.longitude)
    };

    return (
      <div className="card appointment-detail-page">
        <PageTitleComponent title="Walk Map" />
        {route.length ? (
          <WalkRouteMap route={route} marker={marker} />
        ) : (
          <div className="message">
            We're sorry, there's no walk map for this appointment.
          </div>
        )}
      </div>
    );
  }
}
